// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nA.img-link[data-v-3dbf36f8] {\r\n        color: transparent;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
